export const ROOT = '/';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const RECOVER_PASSWORD = '/recover/:token?';
export const HOTELS = '/hotels';
export const HOTELS_SEARCH = `${HOTELS}/search`;
export const HOTEL_DETAIL = `${HOTELS}/detail`;
export const HOTEL_BOOKING = `${HOTELS}/booking`;
export const PAYMENTS_HOTELS = `${HOTELS}/payments`;
export const BOOKING_DETAIL = `/booking/detail`;
export const HOTEL_VOUCHER = `${HOTEL_BOOKING}/voucher`;
export const COMPANY = '/company';
export const SELLPOINTS = '/sellpoints';
export const FRANCHISES = '/franchises';
export const WORKWITHUS = '/work-with-us';
export const CONTACT_US = '/contact-us';
export const FIFTEENS = '/fifteens';
export const FLIGHTS = '/flights';

export const PAYMENT_METHODS = '/payment-methods';

export const LOGINMOTOR = `/login-motorstatic/:email?`;
export const PACKAGES = '/packages';
export const RULES = '/rules';
export const ASSIST = '/assist-card';
export const ASSIST_SEARCH = `${ASSIST}/search`;
export const ASSIST_BUY = `${ASSIST}/buy`;
export const ASSIST_PAYMENTS = `${ASSIST}/payments`;
export const ASSIST_PAYMENTS_SUCCESSFUL = `${ASSIST}/payments-successful`;

export const PAYMENTS = '/payment';

export const FLIGHTS_SEARCH = `${FLIGHTS}/search`;
export const FLIGHTS_RESERVE = `${FLIGHTS}/reserve`;
export const FLIGHTS_RESERVE_SUCCESSFUL = `${FLIGHTS}/reserve-successful`;
export const PAYMENTS_FLIGHTS = `${FLIGHTS}/payments`;

export const PLATES = '/plates';
export const PLATES_DETAIL = `${PLATES}/:plateID/detail`;

export const LOTTERY = '/lottery';

export const MAINTENANCE = '/maintenance';
export const OCEANFEST = '/oceanfest';
export const MIGIT = '/migit';
export const MIGIT_URL = 'https://pegasus.systemtours.cloud/';

export const DEFAULT = '*';
